var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-instagram-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram-icon",
    clipPath: "url(#clip-instagram-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337",
    transform: "translate(-638 -4361)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_543",
    "data-name": "Ellipse 543",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(638 4361)",
    fill: "#005f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "instagram",
    d: "M6.64,2h6.72A4.643,4.643,0,0,1,18,6.64v6.72A4.64,4.64,0,0,1,13.36,18H6.64A4.643,4.643,0,0,1,2,13.36V6.64A4.64,4.64,0,0,1,6.64,2M6.48,3.6A2.88,2.88,0,0,0,3.6,6.48v7.04A2.878,2.878,0,0,0,6.48,16.4h7.04a2.88,2.88,0,0,0,2.88-2.88V6.48A2.878,2.878,0,0,0,13.52,3.6H6.48M14.2,4.8a1,1,0,1,1-1,1,1,1,0,0,1,1-1M10,6a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0,1.6A2.4,2.4,0,1,0,12.4,10,2.4,2.4,0,0,0,10,7.6Z",
    transform: "translate(648 4371)",
    fill: "#f5f5f5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.eeebd9751145827c1a388ee8fbeffc80.svg";
export { ForwardRef as ReactComponent };